import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageLocationSettingService {
 
  constructor(private _httpClient: IesHttpClient) {
  }

  // fetch location data based on Id
  getLocationSettingData(id: number) {
    return this._httpClient.get(AppUrl.getLocationSetting, id);
  }

  //Save, Update Location
  updateLocationSetting(params: any) {
    return this._httpClient.post(AppUrl.updateLocationSetting, params);    
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-manage-location-setting.service.ts